var map = {
	"./backgrounds/background-stripes.png": "7ab6",
	"./extras/anchor.png": "c0ec",
	"./fashion-express/A1/FE_A1_back_en.png": "4825",
	"./fashion-express/A1/FE_A1_front_en.png": "8407",
	"./fashion-express/A2/FE_A2_back_en.png": "63ce",
	"./fashion-express/A2/FE_A2_front_en.png": "cf78",
	"./fashion-express/A3/FE_A3_back_en.png": "524a",
	"./fashion-express/A3/FE_A3_front_en.png": "18a2",
	"./fashion-express/A4/FE_A4_back_en.png": "6cf3",
	"./fashion-express/A4/FE_A4_front_en.png": "fe96",
	"./icon.png": "f8a2",
	"./lesson-action-buttons/assignment-upload-hover.png": "1c44",
	"./lesson-action-buttons/assignment-upload.png": "997f",
	"./lesson-action-buttons/completed.png": "cf789",
	"./lesson-action-buttons/pdf-download-hover.png": "3046",
	"./lesson-action-buttons/pdf-download.png": "7623",
	"./loading.png": "cfcf",
	"./logo-watermark.png": "708a",
	"./logo-win.png": "e458",
	"./logo.png": "9d64",
	"./navigation/back-yellow.png": "e111",
	"./navigation/menu-arrow.png": "18e6",
	"./navigation/next-yellow.png": "26f9d",
	"./new-video/arrow-right-yellow.png": "6387",
	"./new-video/toolbar-down28px-white.png": "6805",
	"./new-video/toolbar-down28px-yellow.png": "d627",
	"./new-video/toolbar-side-menu-white.png": "2dd4",
	"./new-video/toolbar-side-menu-yellow.png": "32a5",
	"./new-video/toolbar-side28px-white.png": "8f49",
	"./new-video/toolbar-side28px-yellow.png": "501c",
	"./page-header/assignments.png": "8a05",
	"./page-header/progress.png": "e5ff",
	"./pattern-grading/A01/PGR_A01_back_en.png": "1980",
	"./pattern-grading/A01/PGR_A01_front_en.png": "ee71",
	"./pattern-grading/A02/PGR_A02_back_en.png": "9732",
	"./pattern-grading/A02/PGR_A02_front_en.png": "5b94",
	"./pattern-grading/A03/PGR_A03_back_en.png": "8d23",
	"./pattern-grading/A03/PGR_A03_front_en.png": "0e93",
	"./pattern-grading/A04/PGR_A04_back_en.png": "a005",
	"./pattern-grading/A04/PGR_A04_front_en.png": "bd8f",
	"./pattern-grading/A05/PGR_A05_back_cross_diagonal_en.png": "d051",
	"./pattern-grading/A05/PGR_A05_back_cross_diagonal_horizontal_en.png": "5e2c",
	"./pattern-grading/A05/PGR_A05_back_cross_en.png": "72cdb",
	"./pattern-grading/A05/PGR_A05_back_cross_horizontal_en.png": "1a1a",
	"./pattern-grading/A05/PGR_A05_back_diagonal_en.png": "3d23",
	"./pattern-grading/A05/PGR_A05_back_diagonal_horizontal_en.png": "c91e",
	"./pattern-grading/A05/PGR_A05_back_en.png": "7f77",
	"./pattern-grading/A05/PGR_A05_back_horizontal_en.png": "a456",
	"./pattern-grading/A05/PGR_A05_front_cross_diagonal_en.png": "2ed3",
	"./pattern-grading/A05/PGR_A05_front_cross_diagonal_horizontal_en.png": "eeb0",
	"./pattern-grading/A05/PGR_A05_front_cross_horizontal_en.png": "67ae",
	"./pattern-grading/A05/PGR_A05_front_diagonal_en.png": "7e66",
	"./pattern-grading/A05/PGR_A05_front_diagonal_horizontal_en.png": "ad6f",
	"./pattern-grading/A05/PGR_A05_front_en.png": "3cee",
	"./pattern-grading/A05/PGR_A05_front_horizontal_en.png": "96f1",
	"./pattern_making/A01/PM_A01_back_de.png": "e1ba",
	"./pattern_making/A01/PM_A01_back_el.png": "f5e5",
	"./pattern_making/A01/PM_A01_back_en.png": "edcc",
	"./pattern_making/A01/PM_A01_back_fr.png": "5ce1",
	"./pattern_making/A01/PM_A01_front_de.png": "d671",
	"./pattern_making/A01/PM_A01_front_el.png": "92a6",
	"./pattern_making/A01/PM_A01_front_en.png": "a741",
	"./pattern_making/A01/PM_A01_front_fr.png": "79d8",
	"./pattern_making/A02/PM_A02_back_cross_diagonal_en.png": "3c438",
	"./pattern_making/A02/PM_A02_back_cross_diagonal_horizontal_en.png": "3068",
	"./pattern_making/A02/PM_A02_back_cross_en.png": "e6c8",
	"./pattern_making/A02/PM_A02_back_cross_horizontal_en.png": "276d",
	"./pattern_making/A02/PM_A02_back_diagonal_en.png": "ab35",
	"./pattern_making/A02/PM_A02_back_diagonal_horizontal_en.png": "cf41",
	"./pattern_making/A02/PM_A02_back_en.png": "74af",
	"./pattern_making/A02/PM_A02_back_horizontal_en.png": "f66f",
	"./pattern_making/A02/PM_A02_front_cross_diagonal_en.png": "adc5",
	"./pattern_making/A02/PM_A02_front_cross_diagonal_horizontal_en.png": "5b0e",
	"./pattern_making/A02/PM_A02_front_cross_en.png": "fcb6",
	"./pattern_making/A02/PM_A02_front_cross_horizontal_en.png": "32b1",
	"./pattern_making/A02/PM_A02_front_diagonal_en.png": "1ed0",
	"./pattern_making/A02/PM_A02_front_diagonal_horizontal_en.png": "98f0",
	"./pattern_making/A02/PM_A02_front_en.png": "67c2",
	"./pattern_making/A02/PM_A02_front_horizontal_en.png": "e452",
	"./pattern_making/A03/PM_A03_back_en.png": "cf26",
	"./pattern_making/A03/PM_A03_front_en.png": "1e81",
	"./pattern_making/A04/PM_A04_back_en.png": "4834",
	"./pattern_making/A04/PM_A04_front_en.png": "850e",
	"./pattern_making/A11/A11_1.png": "b9d7",
	"./pattern_making/A11/A11_2.png": "3c7e",
	"./pattern_making/A11/A11_3.png": "e62d",
	"./ruler/maneken/Body-block.png": "d9b7",
	"./ruler/maneken/Body-block_small.png": "baaa",
	"./ruler/maneken/armholecurve.png": "107a",
	"./ruler/maneken/armholecurve_small.png": "65ab",
	"./ruler/maneken/bustline.png": "7425",
	"./ruler/maneken/bustline_small.png": "431c",
	"./ruler/maneken/cf-cb.png": "3702",
	"./ruler/maneken/cf-cb_small.png": "cf90",
	"./ruler/maneken/chestline.png": "e4c2",
	"./ruler/maneken/chestline_small.png": "fbeb",
	"./ruler/maneken/hipline.png": "ba45",
	"./ruler/maneken/hipline_small.png": "d8d8",
	"./ruler/maneken/maneken_back.png": "0495",
	"./ruler/maneken/maneken_back_merures.png": "839e",
	"./ruler/maneken/maneken_front.png": "ca36",
	"./ruler/maneken/maneken_front_merures.png": "3cba",
	"./ruler/maneken/maneken_pos_1.png": "6920",
	"./ruler/maneken/maneken_pos_1_back.png": "b789",
	"./ruler/maneken/maneken_pos_2.png": "2892",
	"./ruler/maneken/maneken_pos_2_back.png": "37b1",
	"./ruler/maneken/maneken_pos_3.png": "783d",
	"./ruler/maneken/maneken_pos_3_back.png": "f4b4",
	"./ruler/maneken/maneken_pos_4.png": "ec25",
	"./ruler/maneken/maneken_pos_4_back.png": "03a9",
	"./ruler/maneken/maneken_pos_5.png": "cd83",
	"./ruler/maneken/maneken_pos_5_back.png": "a8d1",
	"./ruler/maneken/maneken_pos_6.png": "e7c3",
	"./ruler/maneken/maneken_pos_6_back.png": "767c",
	"./ruler/maneken/maneken_pos_7.png": "b740",
	"./ruler/maneken/maneken_pos_7_back.png": "5909",
	"./ruler/maneken/maneken_pos_8.png": "6719",
	"./ruler/maneken/maneken_pos_9.png": "cc60",
	"./ruler/maneken/neckcurve.png": "f32a",
	"./ruler/maneken/neckcurve_small.png": "6ffa",
	"./ruler/maneken/rouler_positions_1.png": "a8d0",
	"./ruler/maneken/rouler_positions_1_back.png": "0761",
	"./ruler/maneken/rouler_positions_2.png": "7d22",
	"./ruler/maneken/rouler_positions_2_back.png": "5f5d",
	"./ruler/maneken/rouler_positions_3.png": "c24a",
	"./ruler/maneken/rouler_positions_3_back.png": "09de",
	"./ruler/maneken/rouler_positions_4.png": "4867",
	"./ruler/maneken/rouler_positions_4_back.png": "9f05",
	"./ruler/maneken/rouler_positions_5.png": "06bc",
	"./ruler/maneken/rouler_positions_5_back.png": "a0ee",
	"./ruler/maneken/rouler_positions_6.png": "2b9e",
	"./ruler/maneken/rouler_positions_6_back.png": "4112",
	"./ruler/maneken/rouler_positions_7.png": "019e",
	"./ruler/maneken/rouler_positions_7_back.png": "460e",
	"./ruler/maneken/rouler_positions_8.png": "f008",
	"./ruler/maneken/rouler_positions_9.png": "b324",
	"./ruler/maneken/rouler_positions_back.png": "990a",
	"./ruler/maneken/rouler_positions_front.png": "2884",
	"./ruler/maneken/shoulderseam.png": "81c8",
	"./ruler/maneken/shoulderseam_small.png": "7a7c",
	"./ruler/maneken/sideseam.png": "1fda",
	"./ruler/maneken/sideseam_small.png": "8263",
	"./ruler/maneken/waistline.png": "6611",
	"./ruler/maneken/waistline_small.png": "eb38",
	"./slideshow/block.png": "2694",
	"./slideshow/blouse.png": "bae9",
	"./slideshow/body.png": "6e5a",
	"./slideshow/grid.png": "8e16",
	"./slideshow/height-num.png": "ed86",
	"./slideshow/measures.png": "ec78",
	"./slideshow/numbers1-1.png": "cee5",
	"./slideshow/numbers1-2.png": "72cd",
	"./slideshow/numbers2-1.png": "44cb",
	"./slideshow/numbers2-2.png": "b5d9",
	"./slideshow/right-bar.png": "aa27",
	"./slideshow/toolbar-down28px-white.png": "32bc",
	"./slideshow/toolbar-down28px-yellow.png": "3eda",
	"./slideshow/xy-nums.png": "e93d",
	"./slideshow/xy-nums1.png": "83f0",
	"./slideshow/xy-nums2.png": "f605",
	"./tools/bgk.png": "f1be",
	"./tools/btn_bkg_check.png": "12d4",
	"./tools/btn_bkg_uncheck.png": "a027",
	"./tools/btn_mnk_check.png": "cf46",
	"./tools/btn_mnk_uncheck.png": "a171",
	"./tools/btn_reset_check.png": "5218",
	"./tools/btn_reset_uncheck.png": "edf8",
	"./tools/btn_rlrbck_check.png": "0cd2",
	"./tools/btn_rlrbck_uncheck.png": "3620",
	"./tools/btn_rlrfrnt_check.png": "31db",
	"./tools/btn_rlrfrnt_uncheck.png": "6150",
	"./tools/btn_rlrmove_check.png": "6815",
	"./tools/btn_rlrmove_uncheck.png": "15ea",
	"./tools/btn_rlrzoom_check.png": "a49c",
	"./tools/btn_rlrzoom_uncheck.png": "9049"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";